import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Modules
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Dialog Components
import { AssetCategoryDialogComponent } from '../../asset-management/asset-categories/asset-category-dialog.component';
import { StockMovementDialogComponent } from '../../inventory-management/stock-movements/stock-movement-dialog.component';
import { PurchaseOrderDialogComponent } from '../../inventory-management/purchase-orders/purchase-order-dialog.component';

@NgModule({
  declarations: [
    AssetCategoryDialogComponent,
    StockMovementDialogComponent,
    PurchaseOrderDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatSnackBarModule
  ],
  entryComponents: [
    AssetCategoryDialogComponent,
    StockMovementDialogComponent,
    PurchaseOrderDialogComponent
  ]
})
export class DialogsModule { }
